import { Chip, Stack, Typography } from "@mui/material";
import { OrbitLPhase } from "Infrastructure/Api/Api";
import { Resources, useResource } from "Translations/Resources";

const RESOURCES = Resources.Components.Merchant.OrbitL;

type OrbitLStatusDisplayProps = {
  phase: OrbitLPhase;
};

type ChipColor =
  | "default"
  | "primary"
  | "success"
  | "warning"
  | "info"
  | "error";

const phaseColors: Record<OrbitLPhase, ChipColor> = {
  [OrbitLPhase.RequiresCompletion]: "warning",
  [OrbitLPhase.ReadyToDownloadContract]: "info",
  [OrbitLPhase.ContractDownloaded]: "info",
  [OrbitLPhase.SubmittedToComgate]: "primary",
  [OrbitLPhase.ProcessingByComgate]: "primary",
  [OrbitLPhase.TerminalDispatched]: "success",
  [OrbitLPhase.Completed]: "success",
};

export const OrbitLStatusDisplay = ({ phase }: OrbitLStatusDisplayProps) => {
  const { t } = useResource();

  const phaseLabels: Record<OrbitLPhase, string> = {
    [OrbitLPhase.RequiresCompletion]: t(RESOURCES.Phase.RequiresCompletion),
    [OrbitLPhase.ReadyToDownloadContract]: t(
      RESOURCES.Phase.ReadyToDownloadContract,
    ),
    [OrbitLPhase.ContractDownloaded]: t(RESOURCES.Phase.ContractDownloaded),
    [OrbitLPhase.SubmittedToComgate]: t(RESOURCES.Phase.SubmittedToComgate),
    [OrbitLPhase.ProcessingByComgate]: t(RESOURCES.Phase.ProcessingByComgate),
    [OrbitLPhase.TerminalDispatched]: t(RESOURCES.Phase.TerminalDispatched),
    [OrbitLPhase.Completed]: t(RESOURCES.Phase.Completed),
  };

  return (
    <Stack
      direction="row"
      justifyContent="space-between"
      alignItems="center"
      p={2}
      bgcolor="background.paper"
      borderRadius={1}
      border={1}
      borderColor="divider"
    >
      <Stack gap={1}>
        <Typography variant="subtitle2" color="text.secondary">
          {t(RESOURCES.StatusLabel)}
        </Typography>
        <Chip
          label={phaseLabels[phase]}
          color={phaseColors[phase]}
          size="medium"
        />
      </Stack>
    </Stack>
  );
};
